import React from "react";
import { useChatContext } from "../../../contexts/ChatContext";
import { TaskStatus, TaskType, useTasksContext } from "../../../contexts/TasksContext";
import ChatItemRenderer from "./ChatItemRenderer";
import Loader from "./Loader";

interface ChatItemsDisplayProps {
  displaySources: boolean;
  displayCarousel: boolean;
}  
const ChatItemsDisplay: React.FC<ChatItemsDisplayProps> = ({
  displaySources,
  displayCarousel,
}) => {
  const { chatItems, isLoadingSelectedThread, selectedThread } = useChatContext();
  const { tasks } = useTasksContext();
  const runningTask = tasks.find(
    (t) =>
      t.type === TaskType.LEGAL_SEARCH &&
      t.threadId === selectedThread?.id &&
      t.status !== TaskStatus.COMPLETED &&
      t.status !== TaskStatus.CANCELLED &&
      t.status !== TaskStatus.ERROR
  );
  const loaderText = (() => {
    if (!runningTask) return "Generating response...";
    const total = Math.max(1, runningTask.file.nbPages || 1);
    const processed = Math.max(0, Math.min(runningTask.file.nbProcessed || 0, total));
    const pct = Math.round((processed / total) * 100);
    return `Generating response... ${pct}%`;
  })();
  return (
    <>
      {chatItems.map((chatItem) => (
        <div key={chatItem.id} className="mb-2">
          <ChatItemRenderer
            chatItem={chatItem}
            displaySources={displaySources}
            displayCarousel={displayCarousel}
          />
        </div>
      ))}
      {isLoadingSelectedThread && <Loader text={loaderText} />}
    </>
  );
};
export default ChatItemsDisplay;
